module.exports = __webpack_public_path__ + "img/avalanche.e6e051de.png";